/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shareloadfailed2Inputs */

const en_shareloadfailed2 = /** @type {(inputs: Shareloadfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The links could not be loaded.`)
};

const de_shareloadfailed2 = /** @type {(inputs: Shareloadfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Links konnten nicht geladen werden.`)
};

/**
* | output |
* | --- |
* | "The links could not be loaded." |
*
* @param {Shareloadfailed2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const shareloadfailed2 = /** @type {((inputs?: Shareloadfailed2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shareloadfailed2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shareloadfailed2(inputs)
	return de_shareloadfailed2(inputs)
});
export { shareloadfailed2 as "shareLoadFailed" }